"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[75842],{

/***/ 29921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.components.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/en.es.js
var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Thu gọn": "Collapse",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time",
	"Tìm kiếm gần đây": "Recent search",
	"Chọn khu vực nhận hàng": "Select the location",
	"Vui lòng chọn khu vực nhận hàng của bạn": "Please select your location",
	"Tìm kiếm Tỉnh/ Thành phố": "Search Province/City",
	"Không tìm thấy tỉnh thành phố nào !!": "No provice/city is found !!",
	"Khi thay đổi thông tin đơn hàng thanh toán lại, đơn hiện tại sẽ bị hủy. Giá và khuyến mại đơn hàng có thể bị thay đổi. Bạn có chắc chắn muốn thực hiện thao tác này?": "When changing payment order information, current order will be canceled. Order prices and promotions are subject to change. Are you sure you want to perform this action?",
	"Trường hợp muốn thay đổi hình thức thanh toán hoặc các thông tin khác, vui lòng": "If you want to change your payment configuration or other information, please",
	"Bấm vào đây": "Click here",
	"Xem chi tiết": "View detail",
	"Cần thanh toán": "Need to pay",
	"Giao hàng bởi": "Delivered by",
	"Mã vận đơn": "Shipment code",
	"Cung cấp bởi": "Provided by",
	"Combo giảm ~": "Combo discount ~"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "teko-ecommerce";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), { ns: NAMESPACE }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 315436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AuthService": function() { return /* reexport safe */ _service_es_js__WEBPACK_IMPORTED_MODULE_1__.e; },
/* harmony export */   "accessTokenInterceptor": function() { return /* reexport safe */ _interceptor_es_js__WEBPACK_IMPORTED_MODULE_0__.E; },
/* harmony export */   "getAccessToken": function() { return /* reexport safe */ _interceptor_es_js__WEBPACK_IMPORTED_MODULE_0__.h; },
/* harmony export */   "userManager": function() { return /* reexport safe */ _user_es_js__WEBPACK_IMPORTED_MODULE_2__.Z; }
/* harmony export */ });
/* harmony import */ var _interceptor_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(847143);
/* harmony import */ var _service_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76500);
/* harmony import */ var _user_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(799002);





/***/ }),

/***/ 508728:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var Api = __webpack_require__(799278);

const getError = (resp) => {
  const message = resp.message;
  return new Api.ApiError(message, resp.statusCode, resp);
};

exports.getError = getError;


/***/ }),

/***/ 311663:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var auth = __webpack_require__(315436);
var Api = __webpack_require__(799278);
var error = __webpack_require__(508728);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Api__default = /*#__PURE__*/_interopDefaultLegacy(Api);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const LS_CART_TOKEN = "cart_token";
const cartTokenHeader = "x-cart-token";
const getCartToken = (localStorageKey) => localStorage.getItem(localStorageKey);
const setCartToken = (token, localStorageKey = LS_CART_TOKEN) => localStorage.setItem(localStorageKey, token);
const defaultCartValue = {
  id: "",
  grandTotal: 0,
  orderCoupons: {
    applicableCoupons: [],
    inapplicableCoupons: []
  },
  orderLines: [],
  promotions: [],
  shippingFee: 0,
  subTotal: 0,
  totalDiscount: 0,
  eVouchers: [],
  allowToRequestOnDemandDiscount: false
};
const parseJWT = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    return JSON.parse(jsonPayload)["cid"];
  } catch (e) {
    return null;
  }
};
class CartService {
  constructor(cartApiUrl, localStorageKey = LS_CART_TOKEN, language, options) {
    this.getCart = async (params) => {
      const cartToken = getCartToken(this.localStorageKey);
      const accessToken = auth.getAccessToken();
      return !cartToken && !accessToken ? Promise.resolve(defaultCartValue) : this.cartApi.get("/api/v1/cart", { params: __spreadValues({}, params) }).then(({ data }) => data.result);
    };
    this.addToCart = async (params, body) => {
      const { data, headers } = await this.cartApi.post("api/v1/cart/add-to-cart", body, { params: __spreadValues({}, params) });
      const token = headers[cartTokenHeader];
      if (!!token) {
        localStorage.setItem(this.localStorageKey, token);
      }
      return __spreadProps(__spreadValues({}, data.result), { cartId: parseJWT(token) });
    };
    this.applyCoupon = async (params, body) => {
      const { data } = await this.cartApi.post("api/v1/cart/apply-coupon", body, {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.removeCoupon = (params, body) => {
      return this.cartApi.delete("api/v1/cart/clear-coupon", body, { params: __spreadValues({}, params) });
    };
    this.clearCart = (params) => {
      return this.cartApi.delete("api/v1/cart", null, {
        params: __spreadValues({}, params)
      });
    };
    this.updateOrderLine = async (params, id, body) => {
      return this.cartApi.put(`api/v1/cart/order-lines/${id}`, body, {
        params: __spreadProps(__spreadValues({}, params), { graceful: true })
      }).then(({ data }) => Promise.resolve(data.result));
    };
    this.updateSellerItems = (params, sellerId, selected) => {
      return this.cartApi.put("api/v1/cart/order-items", { selected }, { params: __spreadProps(__spreadValues({}, params), { sellerId }) });
    };
    this.removeOrderLine = async (params, id) => {
      return (await this.cartApi.delete)(`api/v1/cart/order-lines/${id}`, null, {
        params: __spreadValues({}, params)
      });
    };
    this.setShippingAddress = (params, selectedAddress) => {
      const fullAddress = [
        selectedAddress.address,
        selectedAddress.wardName,
        selectedAddress.districtName,
        selectedAddress.provinceName
      ].filter(Boolean).join(", ");
      const infoSetShippingAddr = __spreadProps(__spreadValues({
        addressId: selectedAddress.addressId || selectedAddress.id,
        wardCode: (selectedAddress == null ? void 0 : selectedAddress.wardCode) || "",
        districtCode: selectedAddress == null ? void 0 : selectedAddress.districtCode,
        provinceCode: selectedAddress == null ? void 0 : selectedAddress.provinceCode,
        wardName: (selectedAddress == null ? void 0 : selectedAddress.wardName) || "",
        districtName: selectedAddress == null ? void 0 : selectedAddress.districtName,
        provinceName: selectedAddress == null ? void 0 : selectedAddress.provinceName,
        address: selectedAddress == null ? void 0 : selectedAddress.address,
        name: selectedAddress == null ? void 0 : selectedAddress.name
      }, (selectedAddress == null ? void 0 : selectedAddress.email) && { email: selectedAddress.email }), {
        telephone: selectedAddress == null ? void 0 : selectedAddress.telephone,
        addressNote: "",
        fullAddress: selectedAddress.fullAddress || fullAddress
      });
      return this.cartApi.post(`api/v1/cart/shipping-address`, infoSetShippingAddr, { params: __spreadValues({}, params) });
    };
    this.getPaymentMethod = async (params, orderCode) => {
      const { data } = await this.cartApi.get("api/v1/cart/payment-methods-v2", {
        params: __spreadValues(__spreadValues({}, params), orderCode ? { orderCode } : {})
      });
      return data.result;
    };
    this.checkout = async (params, body) => {
      var _a, _b, _c, _d;
      const { data } = await this.cartApi.post("api/v1/cart/checkout", body, {
        params: __spreadValues({}, params)
      });
      return __spreadProps(__spreadValues({}, data.result), {
        orderId: ((_a = data.result) == null ? void 0 : _a.orderIdString) || ((_b = data.result) == null ? void 0 : _b.orderId),
        id: ((_c = data.result) == null ? void 0 : _c.orderIdString) || ((_d = data.result) == null ? void 0 : _d.orderId),
        get remainPayment() {
          return parseFloat(data.result.grandTotal.toString()) - data.result.totalPaid;
        }
      });
    };
    this.getOrderByCode = async (params, code) => {
      const { data } = await this.cartApi.get(`/api/v1/orders/${code}`, {
        params: __spreadValues({}, params)
      });
      const order = data.result;
      return __spreadProps(__spreadValues({}, order), {
        orderId: (order == null ? void 0 : order.idString) || (order == null ? void 0 : order.id),
        id: (order == null ? void 0 : order.idString) || (order == null ? void 0 : order.id),
        grandTotal: parseInt(order.grandTotal),
        get remainPayment() {
          var _a;
          const prevPayment = ((_a = order == null ? void 0 : order.payments) == null ? void 0 : _a.reduce((amount, currentPayment) => amount + currentPayment.amount, 0)) || 0;
          return parseFloat(order.grandTotal.toString()) - prevPayment;
        }
      });
    };
    this.getApplicableServices = async (params) => {
      const { data } = await this.cartApi.get("api/v1/cart/applicable-services", {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.findApplicableServices = async (params, body) => {
      const { data } = await this.cartApi.post("/api/v1/cart/applicable-services", body, {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.getDeliveryOptions = async (params, body) => {
      const { data } = await this.cartApi.post("/api/v1/cart/delivery-options", body, {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.applyServiceToCart = async (params, body) => {
      const { data } = await this.cartApi.put("/api/v1/cart/apply-service", body, { params: __spreadValues({}, params) });
      return data.result;
    };
    this.applyPaymentMethodToCart = async (params, body) => {
      const { data } = await this.cartApi.put("/api/v1/cart/apply-payment-method", body, { params: __spreadValues({}, params) });
      return data.result;
    };
    this.importOrder = async (payload, query) => {
      const { data } = await this.cartApi.post("/api/v1/orders", payload, {
        params: __spreadValues({}, query)
      });
      return data.result;
    };
    this.cartApi = new Api__default["default"](cartApiUrl, error.getError);
    this.localStorageKey = localStorageKey;
    if (typeof (options == null ? void 0 : options.getCustomAccessToken) === "function") {
      this.cartApi.addInterceptor((request) => {
        var _a;
        request.headers.set("Authorization", `Bearer ${(_a = options.getCustomAccessToken) == null ? void 0 : _a.call(options)}`);
      });
    } else {
      this.cartApi.addInterceptor(auth.accessTokenInterceptor);
    }
    this.cartApi.addInterceptor((request) => {
      var _a;
      if (typeof window === "undefined" && !(options == null ? void 0 : options.isSyncCartOffline))
        return;
      if (options == null ? void 0 : options.cartToken) {
        request.headers.set(cartTokenHeader, options == null ? void 0 : options.cartToken);
      } else {
        const cartToken = ((_a = this.getCartToken) != null ? _a : getCartToken)(localStorageKey);
        if (cartToken) {
          request.headers.set(cartTokenHeader, cartToken);
        }
      }
    });
    this.cartApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", language || "*");
    });
  }
  setParams({ getCartToken: getCartToken2 }) {
    this.getCartToken = getCartToken2;
  }
}

exports.CartService = CartService;
exports.defaultCartValue = defaultCartValue;
exports.parseJWT = parseJWT;
exports.setCartToken = setCartToken;


/***/ }),

/***/ 986778:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var Api = __webpack_require__(799278);

const getError = (resp) => {
  const message = resp.message;
  return new Api.ApiError(message, resp.code, resp);
};

exports.getError = getError;


/***/ }),

/***/ 511335:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var service = __webpack_require__(463195);
var types = __webpack_require__(629391);
var utils = __webpack_require__(756539);
var error = __webpack_require__(986778);



__webpack_unused_export__ = service.CartService;
__webpack_unused_export__ = service.parseJWT;
__webpack_unused_export__ = service.parseTerminalId;
__webpack_unused_export__ = service.parseToken;
__webpack_unused_export__ = types.AllowedUserActionItem;
exports.RN = types.CartDeliveryType;
__webpack_unused_export__ = types.CheckoutAllowedUserActions;
__webpack_unused_export__ = types.CustomerType;
__webpack_unused_export__ = types.DeliveryTimeSlotType;
exports.VM = types.PromotionGroupType;
__webpack_unused_export__ = types.RequiredInfoToCheckout;
__webpack_unused_export__ = types.UserActionType;
__webpack_unused_export__ = utils.BUY_NOW_CARTS_KEY;
exports.xz = utils.BUY_NOW_CART_EXPIRED_ERROR_CODE;
__webpack_unused_export__ = utils.BUY_NOW_CART_KEY_LENGTH;
__webpack_unused_export__ = utils.BUY_NOW_ISOLATED_CART_TYPE;
__webpack_unused_export__ = utils.IsolatedCartType;
__webpack_unused_export__ = utils.defaultCart;
__webpack_unused_export__ = utils.getBuyNowKey;
__webpack_unused_export__ = utils.getCartToken;
__webpack_unused_export__ = utils.removeCartToken;
__webpack_unused_export__ = utils.removeOldBuyNowCart;
__webpack_unused_export__ = utils.setCartInfoToLocalStorage;
__webpack_unused_export__ = utils.setCartToken;
__webpack_unused_export__ = utils.storeBuyNowCartKey;
__webpack_unused_export__ = utils.storeCartTokenHamper;
__webpack_unused_export__ = error.getError;


/***/ }),

/***/ 463195:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var Api = __webpack_require__(799278);
var auth = __webpack_require__(315436);
var utils$1 = __webpack_require__(775002);
var service = __webpack_require__(311663);
var error = __webpack_require__(986778);
var utils = __webpack_require__(756539);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Api__default = /*#__PURE__*/_interopDefaultLegacy(Api);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const cartTokenHeaderKey = "x-cart-token";
const resolveValue = (value) => {
  return typeof value === "function" ? value() : value;
};
const parseToken = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};
const parseJWT = (token) => {
  try {
    const parsedToken = parseToken(token);
    if (!!parsedToken) {
      return parsedToken["cid"];
    }
    return null;
  } catch (e) {
    return null;
  }
};
const parseTerminalId = (token) => {
  try {
    const parsedToken = parseToken(token);
    if (!!parsedToken) {
      return parsedToken["tid"];
    }
    return void 0;
  } catch (e) {
    return void 0;
  }
};
class CartService {
  constructor(apiUrl, options) {
    this.cartApi = new Api__default["default"](apiUrl, error.getError);
    if (typeof (options == null ? void 0 : options.getCustomAccessToken) === "function") {
      this.cartApi.addInterceptor((request) => {
        var _a;
        request.headers.set("Authorization", `Bearer ${(_a = options.getCustomAccessToken) == null ? void 0 : _a.call(options)}`);
      });
    } else {
      this.cartApi.addInterceptor(auth.accessTokenInterceptor);
    }
    this.cartApi.addInterceptor((req) => {
      if (typeof window === "undefined" || req.headers.get(cartTokenHeaderKey) !== null)
        return;
      if (options == null ? void 0 : options.cartToken) {
        req.headers.set(cartTokenHeaderKey, options == null ? void 0 : options.cartToken);
      } else {
        const cartToken = typeof this.getCartToken === "function" ? this.getCartToken() : utils.getCartToken();
        if (cartToken) {
          req.headers.set(cartTokenHeaderKey, cartToken);
        }
      }
    });
    this.cartApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", (options == null ? void 0 : options.language) || "*");
    });
    this.cartApi.addInterceptor((request) => {
      request.headers.set("use-combo-v2", `${(options == null ? void 0 : options.useComboV2) || false}`);
    });
    this.cartApi.addInterceptor((request) => {
      request.headers.set("use-exclusion-v2", `${(options == null ? void 0 : options.useExclusionV2) || false}`);
    });
    this.location = (options == null ? void 0 : options.location) || void 0;
    this.terminal = (options == null ? void 0 : options.terminal) || void 0;
    this.terminalId = (options == null ? void 0 : options.terminalId) || void 0;
    this.getFullCart = (options == null ? void 0 : options.getFullCart) || void 0;
    this.v1 = new service.CartService(apiUrl);
  }
  getCartId(cartToken) {
    var _a;
    const token = cartToken || ((_a = this.getCartToken) == null ? void 0 : _a.call(this));
    return typeof token === "string" ? parseJWT(token) : void 0;
  }
  getParams(configs) {
    return {
      getFullCart: this.getFullCart,
      location: this.location,
      terminal: !(configs == null ? void 0 : configs.noTerminal) ? resolveValue(this.terminal) : void 0,
      terminalId: !(configs == null ? void 0 : configs.noTerminalId) ? resolveValue(this.terminalId) : void 0,
      hasAllApplicableOrderPromotions: this.hasAllApplicableOrderPromotions
    };
  }
  setParams({
    getFullCart,
    location,
    terminal,
    terminalId,
    getCartToken: getCartToken2,
    hasAllApplicableOrderPromotions
  }) {
    this.getFullCart = typeof getFullCart !== "undefined" ? getFullCart : this.getFullCart;
    this.location = typeof location !== "undefined" ? location : this.location;
    this.terminal = typeof terminal !== "undefined" ? terminal : this.terminal;
    this.terminalId = typeof terminalId !== "undefined" ? terminalId : this.terminalId;
    this.getCartToken = typeof getCartToken2 !== "undefined" ? getCartToken2 : this.getCartToken;
    this.hasAllApplicableOrderPromotions = typeof hasAllApplicableOrderPromotions !== "undefined" ? hasAllApplicableOrderPromotions : this.hasAllApplicableOrderPromotions;
  }
  async getCart(oldTerminalId) {
    const { data, headers } = await this.cartApi.get("/api/v2/carts", {
      params: __spreadProps(__spreadValues({}, this.getParams()), { oldTerminalId })
    });
    if (!!oldTerminalId) {
      const newToken = headers[cartTokenHeaderKey];
      const oldToken = typeof this.getCartToken === "function" ? this.getCartToken() : utils.getCartToken();
      if (oldToken)
        utils.setCartInfoToLocalStorage(this.getCartId(newToken), {
          newCartToken: newToken,
          oldCartToken: oldToken,
          terminalId: parseTerminalId(newToken),
          cartDiffDetails: data == null ? void 0 : data.message
        });
    }
    return __spreadProps(__spreadValues({}, data == null ? void 0 : data.data), {
      message: !!oldTerminalId ? data == null ? void 0 : data.message : void 0
    }) || utils.defaultCart;
  }
  async applyPromotion(applyPromotionRequest) {
    const { ppmPromotionId, ppmCode, itemId, isForceApply, promotionSource } = applyPromotionRequest;
    const res = await this.cartApi.put("/api/v2/carts/promotions", {
      ppmPromotionId,
      ppmCode,
      itemId,
      isForceApply,
      promotionSource
    }, {
      params: this.getParams()
    });
    return res == null ? void 0 : res.data;
  }
  async removePromotion(removePromotionRequest) {
    const { cartPromotionId } = removePromotionRequest;
    const res = await this.cartApi.delete("/api/v2/carts/promotions", {
      cartPromotionId
    }, {
      params: this.getParams()
    });
    return res == null ? void 0 : res.data;
  }
  async recordOrder(recordOrderRequest, cartToken) {
    const res = await this.cartApi.post("/api/v2/carts/record", recordOrderRequest, {
      params: this.getParams(),
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
    return res == null ? void 0 : res.data;
  }
  async getAllCartTokens(configs) {
    var _a, _b;
    const res = await this.cartApi.get("/api/v2/cart-tokens", {
      params: this.getParams(configs)
    });
    if (!Array.isArray((_a = res.data) == null ? void 0 : _a.data)) {
      return [];
    }
    return (_b = res.data) == null ? void 0 : _b.data;
  }
  async createNewCart({
    deviceSerialNumber
  }) {
    var _a;
    const res = await this.cartApi.post("/api/v2/carts", {}, {
      params: __spreadProps(__spreadValues({}, this.getParams()), {
        deviceSerialNumber
      })
    });
    const data = ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || { cart: utils.defaultCart, cartToken: "" };
    return data;
  }
  async deleteCart(cartToken) {
    await this.cartApi.delete("/api/v2/carts", void 0, {
      params: this.getParams(),
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
  }
  async loadConfirmationCart({
    deviceSerialNumber
  }) {
    var _a;
    const res = await this.cartApi.get("/api/v2/carts/confirmation", {
      params: __spreadProps(__spreadValues({}, this.getParams()), {
        deviceSerialNumber
      })
    });
    return ((_a = res.data) == null ? void 0 : _a.data) || utils.defaultCart;
  }
  async getDeliveryOptions({
    deliveryType,
    customerProfileId
  }) {
    var _a;
    const res = await this.cartApi.post("/api/v2/carts/delivery-options", { deliveryType, customerProfileId }, { params: this.getParams() });
    return ((_a = res.data) == null ? void 0 : _a.data) || {};
  }
  async setDeliveryInfo({
    address,
    addressId,
    deliveryType,
    districtId,
    districtName,
    email,
    fullAddress,
    name,
    phone,
    provinceId,
    provinceName,
    siteId,
    wardId,
    wardName,
    getAllApplicablePromotions
  }, optionalParams) {
    var _b;
    const { cartToken, terminalId } = optionalParams || {};
    const generatedFullAddress = [address, wardName, districtName, provinceName].filter(Boolean).join(", ");
    const _a = this.getParams(), { hasAllApplicableOrderPromotions } = _a, rest = __objRest(_a, ["hasAllApplicableOrderPromotions"]);
    const res = await this.cartApi.put("/api/v2/carts/delivery-info", utils$1.cleanObject({
      addressId,
      deliveryType,
      districtId,
      fullAddress: fullAddress || generatedFullAddress,
      name,
      phone,
      provinceId,
      siteId,
      wardId,
      email
    }), {
      params: __spreadProps(__spreadValues({}, rest), {
        getAllApplicablePromotions: getAllApplicablePromotions || hasAllApplicableOrderPromotions,
        terminalId: terminalId || rest.terminalId
      }),
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
    return ((_b = res.data) == null ? void 0 : _b.data) || utils.defaultCart;
  }
  async changeItemPrice({
    itemId,
    consultationFee,
    onDemandDiscount,
    onDemandDiscountReason,
    onDemandDiscountReasonId
  }) {
    var _a;
    const data = await this.cartApi.put("/api/v2/carts/items/price-manual", {
      itemId,
      consultationFee,
      onDemandDiscount,
      onDemandDiscountReason,
      onDemandDiscountReasonId
    }, {
      params: this.getParams()
    });
    return (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.data;
  }
  async applyDeliveryService({
    serviceId
  }) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/delivery-services", { serviceId }, { params: this.getParams() });
    return ((_a = res.data) == null ? void 0 : _a.data) || utils.defaultCart;
  }
  async applyAdditionalService({
    serviceId,
    isEnable
  }) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/additional-services", { serviceId, isEnable }, { params: this.getParams() });
    return ((_a = res.data) == null ? void 0 : _a.data) || utils.defaultCart;
  }
  async applyPaymentMethodToCart({
    paymentMethodCode
  }) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/payment-methods", { paymentMethodCode }, {
      params: this.getParams()
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils.defaultCart;
  }
  async requestItemSku({
    name,
    quantity
  }) {
    const { data, headers } = await this.cartApi.post("api/v2/carts/items/sku-request", { name, quantity }, {
      params: this.getParams()
    });
    const token = headers[cartTokenHeaderKey];
    if (!!token) {
      utils.setCartToken(token);
    }
    return (data == null ? void 0 : data.data) || utils.defaultCart;
  }
  async checkoutOrder({
    order
  }, cartToken) {
    var _a;
    const res = await this.cartApi.post("/api/v2/carts/checkout", { order }, {
      params: this.getParams(),
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
    return (_a = res.data) == null ? void 0 : _a.data;
  }
  async removeItem(removeItemRequest) {
    var _a;
    const { itemId } = removeItemRequest;
    const params = this.getParams();
    const res = await this.cartApi.delete("/api/v2/carts/items", { itemId }, { params });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils.defaultCart;
  }
  async updateItemQuantity(updateItemQuantityRequest) {
    var _a;
    const { itemId, quantity } = updateItemQuantityRequest;
    const body = {
      itemId,
      quantity
    };
    const params = this.getParams();
    const res = await this.cartApi.put("/api/v2/carts/items/quantity", body, {
      params
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils.defaultCart;
  }
  async updateItemNote(updateItemNoteRequest) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/items/note", updateItemNoteRequest, {
      params: this.getParams()
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils.defaultCart;
  }
  async selectItems(selectItemsRequest) {
    var _a;
    const { itemIds, isSelected } = selectItemsRequest;
    const body = {
      itemIds,
      isSelected
    };
    const params = this.getParams();
    const res = await this.cartApi.put("/api/v2/carts/items/selection", body, {
      params
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils.defaultCart;
  }
  async addItems(addItemsRequest, cartToken) {
    const {
      groups,
      override,
      overrideItemId,
      overrideTypes,
      isolatedCartType,
      isSkipHoldInventory
    } = addItemsRequest;
    const body = {
      groups,
      override,
      overrideTypes,
      overrideItemId,
      isolatedCartType,
      isSkipHoldInventory
    };
    const params = this.getParams();
    const { data, headers } = await this.cartApi.post("/api/v2/carts/items", body, {
      params,
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
    const token = headers[cartTokenHeaderKey];
    if (!!token && !cartToken) {
      if (!isolatedCartType) {
        utils.setCartToken(token);
      } else {
        utils.storeBuyNowCartKey({
          key: utils.getBuyNowKey(),
          createdAt: new Date().getTime(),
          cartToken: token
        });
        if (!!isSkipHoldInventory) {
          utils.removeOldBuyNowCart();
          utils.storeCartTokenHamper(token);
        }
      }
    }
    return (data == null ? void 0 : data.data) || utils.defaultCart;
  }
  async recordToPayment({
    payments,
    orderId
  }) {
    const body = { payments, orderId };
    const params = this.getParams();
    const { data } = await this.cartApi.post("/api/v2/carts/record-to-payment", body, {
      params
    });
    return data.data;
  }
  async reCheckout(orderToken) {
    const params = this.getParams();
    const { data } = await this.cartApi.post("/api/v2/carts/checkout-to-payment", { orderToken }, { params });
    return data.data;
  }
  async getOrderPaymentMethod(orderId) {
    var _a;
    const res = await this.cartApi.get("api/v2/orders/payment-info", {
      params: __spreadProps(__spreadValues({}, this.getParams()), { orderId })
    });
    return (_a = res.data) == null ? void 0 : _a.data;
  }
  async updateCartGeneralInfo(payload, cartToken) {
    const res = await this.cartApi.put("/api/v2/carts", payload, {
      params: this.getParams(),
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
    return res == null ? void 0 : res.data.data;
  }
  async applyPaymentAmount(payload) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/payment-amount", payload, {
      params: this.getParams()
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils.defaultCart;
  }
  async getPriceAndPromotion(sku, params) {
    const { data } = await this.cartApi.get(`/api/v2/products/${sku}`, {
      params: __spreadValues(__spreadValues({}, this.getParams()), params)
    });
    return data.data;
  }
  async calculatePrice(body) {
    const { data } = await this.cartApi.post("/api/v2/products/calculate-price", body, { params: this.getParams() });
    return data.data;
  }
}

exports.CartService = CartService;
exports.parseJWT = parseJWT;
exports.parseTerminalId = parseTerminalId;
exports.parseToken = parseToken;


/***/ }),

/***/ 629391:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var AllowedUserActionItem = /* @__PURE__ */ ((AllowedUserActionItem2) => {
  AllowedUserActionItem2["TOGGLE"] = "TOGGLE";
  AllowedUserActionItem2["DELETE"] = "DELETE";
  AllowedUserActionItem2["CHANGE_QUANTITY"] = "CHANGE_QUANTITY";
  AllowedUserActionItem2["REQUEST_ON_DEMAND_DISCOUNT"] = "REQUEST_ON_DEMAND_DISCOUNT";
  AllowedUserActionItem2["REQUEST_CONSULTATION_FEE"] = "REQUEST_CONSULTATION_FEE";
  AllowedUserActionItem2["OPEN_PRODUCT_DETAIL"] = "OPEN_PRODUCT_DETAIL";
  AllowedUserActionItem2["ADD_NOTE"] = "ADD_NOTE";
  return AllowedUserActionItem2;
})(AllowedUserActionItem || {});
var UserActionType = /* @__PURE__ */ ((UserActionType2) => {
  UserActionType2["REQUEST_ON_DEMAND_DISCOUNT"] = "REQUEST_ON_DEMAND_DISCOUNT";
  UserActionType2["REQUEST_CONSULTATION_FEE"] = "REQUEST_CONSULTATION_FEE";
  UserActionType2["USE_DEFERRED_PAYMENT"] = "USE_DEFERRED_PAYMENT";
  UserActionType2["USE_DEPOSIT"] = "USE_DEPOSIT";
  UserActionType2["ADD_CONSULTANT"] = "ADD_CONSULTANT";
  UserActionType2["REQUEST_NEW_SKU"] = "REQUEST_NEW_SKU";
  UserActionType2["CREATE_QUOTATION"] = "CREATE_QUOTATION";
  return UserActionType2;
})(UserActionType || {});
var CartDeliveryType = /* @__PURE__ */ ((CartDeliveryType2) => {
  CartDeliveryType2["DELIVERY_TYPE_UNSPECIFIED"] = "DELIVERY_TYPE_UNSPECIFIED";
  CartDeliveryType2["DELIVERY_TYPE_AT_HOME"] = "DELIVERY_TYPE_AT_HOME";
  CartDeliveryType2["DELIVERY_TYPE_PICKUP"] = "DELIVERY_TYPE_PICKUP";
  CartDeliveryType2["DELIVERY_TYPE_HANDOVER"] = "DELIVERY_TYPE_HANDOVER";
  return CartDeliveryType2;
})(CartDeliveryType || {});
var CheckoutAllowedUserActions = /* @__PURE__ */ ((CheckoutAllowedUserActions2) => {
  CheckoutAllowedUserActions2["PAYMENT"] = "PAYMENT";
  CheckoutAllowedUserActions2["FINISH"] = "FINISH";
  CheckoutAllowedUserActions2["ORDER_LIST"] = "ORDER_LIST";
  CheckoutAllowedUserActions2["QUOTATION_POPUP"] = "QUOTATION_POPUP";
  return CheckoutAllowedUserActions2;
})(CheckoutAllowedUserActions || {});
var DeliveryTimeSlotType = /* @__PURE__ */ ((DeliveryTimeSlotType2) => {
  DeliveryTimeSlotType2["REQUIRED"] = "REQUIRED";
  DeliveryTimeSlotType2["OPTIONAL"] = "OPTIONAL";
  DeliveryTimeSlotType2["NONE"] = "NONE";
  return DeliveryTimeSlotType2;
})(DeliveryTimeSlotType || {});
var CustomerType = /* @__PURE__ */ ((CustomerType2) => {
  CustomerType2["INDIVIDUAL"] = "INDIVIDUAL";
  CustomerType2["FOREIGN"] = "FOREIGN";
  CustomerType2["BUSINESS"] = "BUSINESS";
  CustomerType2["STATE_BUDGET_UNIT"] = "STATE_BUDGET_UNIT";
  return CustomerType2;
})(CustomerType || {});
var PromotionGroupType = /* @__PURE__ */ ((PromotionGroupType2) => {
  PromotionGroupType2["GROUP_TYPE_DEFAULT"] = "GROUP_TYPE_DEFAULT";
  PromotionGroupType2["GROUP_TYPE_SELECTABLE"] = "GROUP_TYPE_SELECTABLE";
  PromotionGroupType2["GROUP_TYPE_EXCLUSIVE"] = "GROUP_TYPE_EXCLUSIVE";
  PromotionGroupType2["GROUP_TYPE_TIER_PROMOTIONS"] = "GROUP_TYPE_TIER_PROMOTIONS";
  return PromotionGroupType2;
})(PromotionGroupType || {});
var RequiredInfoToCheckout = /* @__PURE__ */ ((RequiredInfoToCheckout2) => {
  RequiredInfoToCheckout2["DELIVERY_EMAIL"] = "DELIVERY_EMAIL";
  RequiredInfoToCheckout2["DELIVERY_PHONE"] = "DELIVERY_PHONE";
  return RequiredInfoToCheckout2;
})(RequiredInfoToCheckout || {});

exports.AllowedUserActionItem = AllowedUserActionItem;
exports.CartDeliveryType = CartDeliveryType;
exports.CheckoutAllowedUserActions = CheckoutAllowedUserActions;
exports.CustomerType = CustomerType;
exports.DeliveryTimeSlotType = DeliveryTimeSlotType;
exports.PromotionGroupType = PromotionGroupType;
exports.RequiredInfoToCheckout = RequiredInfoToCheckout;
exports.UserActionType = UserActionType;


/***/ }),

/***/ 756539:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var TerraKit = __webpack_require__(175915);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var TerraKit__default = /*#__PURE__*/_interopDefaultLegacy(TerraKit);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const cartTokenLSKey = "cart_token";
const BUY_NOW_ISOLATED_CART_TYPE = "buy_now";
var IsolatedCartType = /* @__PURE__ */ ((IsolatedCartType2) => {
  IsolatedCartType2["BUY_NOW"] = "buy_now";
  IsolatedCartType2["INSTALLMENT"] = "installment_vnpay";
  return IsolatedCartType2;
})(IsolatedCartType || {});
const BUY_NOW_CARTS_KEY = "buy-now-carts";
const BUY_NOW_CART_KEY_LENGTH = 6;
const BUY_NOW_CART_EXPIRED_ERROR_CODE = 404101;
const getCartToken = () => {
  return localStorage.getItem(cartTokenLSKey);
};
const setCartToken = (value) => {
  localStorage.setItem(cartTokenLSKey, value);
};
const removeCartToken = () => localStorage.removeItem(cartTokenLSKey);
const defaultCart = {
  id: "",
  items: [],
  priceSummary: [
    {
      name: "T\u1ED5ng ti\u1EC1n",
      value: "0\u0111"
    },
    {
      name: "Th\xE0nh ti\u1EC1n",
      value: "0\u0111"
    }
  ],
  grandTotalAmount: 0,
  paidAmount: 0,
  remainingAmount: 0,
  onDemandDiscount: 0,
  allowedUserActions: [],
  promotions: [],
  paymentMethods: [],
  orderTerminalCode: ""
};
const generateRandomString = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
let lastBuyNowKey = "";
const getBuyNowKey = (isReuse) => {
  if (isReuse) {
    return lastBuyNowKey;
  }
  const newBuyNowKey = generateRandomString(BUY_NOW_CART_KEY_LENGTH);
  lastBuyNowKey = newBuyNowKey;
  return newBuyNowKey;
};
const storeBuyNowCartKey = (newBuyNowCart) => {
  if (TerraKit__default["default"].isAvailable())
    return;
  const buyNowCarts = JSON.parse(localStorage.getItem(BUY_NOW_CARTS_KEY) || "[]");
  buyNowCarts.push(newBuyNowCart);
  localStorage.setItem(BUY_NOW_CARTS_KEY, JSON.stringify(buyNowCarts));
};
const removeOldBuyNowCart = () => {
  if (TerraKit__default["default"].isAvailable())
    return;
  const hamperData = JSON.parse(localStorage.getItem("buildHamper") || "{}");
  const oldCartToken = hamperData.cartToken;
  if (!oldCartToken)
    return;
  let buyNowCarts = JSON.parse(localStorage.getItem(BUY_NOW_CARTS_KEY) || "[]");
  buyNowCarts = buyNowCarts.filter((item) => item.cartToken !== oldCartToken);
  localStorage.setItem(BUY_NOW_CARTS_KEY, JSON.stringify(buyNowCarts));
};
const storeCartTokenHamper = (cartToken) => {
  const hamperLocalStorageKey = TerraKit__default["default"].isAvailable() ? "buildHamperApp" : "buildHamper";
  let hamperData = JSON.parse(localStorage.getItem(hamperLocalStorageKey) || "{}");
  hamperData = __spreadProps(__spreadValues({}, hamperData), { cartToken });
  localStorage.setItem(hamperLocalStorageKey, JSON.stringify(hamperData));
};
const setCartInfoToLocalStorage = (cartId, data) => {
  const { newCartToken, oldCartToken, terminalId, cartDiffDetails } = data;
  localStorage.setItem(`cart.${cartId}`, JSON.stringify(__spreadValues(__spreadValues({
    token: newCartToken,
    referencedToken: oldCartToken
  }, terminalId && { terminalId }), cartDiffDetails && { cartDiffDetails })));
};

exports.BUY_NOW_CARTS_KEY = BUY_NOW_CARTS_KEY;
exports.BUY_NOW_CART_EXPIRED_ERROR_CODE = BUY_NOW_CART_EXPIRED_ERROR_CODE;
exports.BUY_NOW_CART_KEY_LENGTH = BUY_NOW_CART_KEY_LENGTH;
exports.BUY_NOW_ISOLATED_CART_TYPE = BUY_NOW_ISOLATED_CART_TYPE;
exports.IsolatedCartType = IsolatedCartType;
exports.defaultCart = defaultCart;
exports.getBuyNowKey = getBuyNowKey;
exports.getCartToken = getCartToken;
exports.removeCartToken = removeCartToken;
exports.removeOldBuyNowCart = removeOldBuyNowCart;
exports.setCartInfoToLocalStorage = setCartInfoToLocalStorage;
exports.setCartToken = setCartToken;
exports.storeBuyNowCartKey = storeBuyNowCartKey;
exports.storeCartTokenHamper = storeCartTokenHamper;


/***/ })

}]);